import React, { useRef, useState } from "react";
import { IconButtonProps } from "./IconButton.types";
import { ButtonContainer, Tooltip } from "./IconButton.styles";
import { Icon } from "components/Icon";
import TooltipPortal from "../../TooltipPortal/TooltipPortal";

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  onClick,
  href,
  altText,
  tooltip,
  tone = "default",
  className,
}) => {
  const buttonRef = useRef<HTMLElement>(null);
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  if (href) {
    return (
      <>
        <ButtonContainer
          as="a"
          href={href}
          aria-label={altText}
          $tone={tone}
          className={className}
          ref={buttonRef as React.RefObject<HTMLAnchorElement>}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Icon glyph={icon} size="lg" />
        </ButtonContainer>
        {tooltip && isHovered && (
          <TooltipPortal targetRef={buttonRef}>
            <Tooltip visible={isHovered}>{tooltip}</Tooltip>
          </TooltipPortal>
        )}
      </>
    );
  }

  return (
    <>
      <ButtonContainer
        as="button"
        onClick={onClick}
        type="button"
        aria-label={altText}
        $tone={tone}
        className={className}
        ref={buttonRef as React.RefObject<HTMLButtonElement>}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Icon glyph={icon} size="lg" />
      </ButtonContainer>
      {tooltip && isHovered && (
        <TooltipPortal targetRef={buttonRef}>
          <Tooltip visible={isHovered}>{tooltip}</Tooltip>
        </TooltipPortal>
      )}
    </>
  );
};

export default IconButton;
